import { GeoZoneOperationConfigWithGracePeriod } from '@EcamModel/model';
import React from 'react';
import { checkValues } from '../configs';
import { Typography } from '@mui/material';
import { GeoZoneOperationConfigDay } from '@EcamModel/model/GeoZoneOperationConfigDay';
import { daysOfWeek, formatTimeFromSeconds } from 'src/helpers';

interface GracePeriodConfigProps {
    change: checkValues;
    configValues?: GeoZoneOperationConfigWithGracePeriod[];
}

export default function GracePeriodConfig(props: GracePeriodConfigProps) {
    return (
        <li>
            <Typography>{`${props.change.key}:`}</Typography>
            {props.configValues?.map((config, index) => (
                <>
                    {(config.GZOConfigGracePeriods ?? []).map((grace, graceIndex) => (
                        <ul
                            key={`grace-period-${graceIndex}`}
                            style={{
                                marginTop: '4px',
                                marginBottom: '4px',
                            }}
                        >
                            <li>
                                <Typography>{`Name: ${grace.Name}`}</Typography>
                            </li>
                            <li>
                                <Typography>{`Grace period: ${grace.GracePeriod}(s)`}</Typography>
                            </li>
                            <ul>
                                {(grace.GZOConfigDays ?? []).map((dayConfig, dayIndex) => (
                                    <li key={`day-config-${dayIndex}`}>{renderGraceConfigDays([dayConfig])}</li>
                                ))}
                            </ul>
                        </ul>
                    ))}
                </>
            ))}
        </li>
    );
}

const renderGraceConfigDays = (graceDays: GeoZoneOperationConfigDay[]) => {
    return (
        <>
            {graceDays.map((day, dayIndex) => (
                <Typography key={dayIndex}>
                    {`${daysOfWeek[day.Weekday - 1]}, `}
                    {`from: ${formatTimeFromSeconds(day.From ?? 0)}, to: ${formatTimeFromSeconds(day.To ?? 0)}${
                        day.AllDay ? ' (All day).' : '.'
                    }`}
                </Typography>
            ))}
        </>
    );
};
